<template>
  <div id="OptionsSlider" class="border-brand-secondary shadow">
    <div class="options-slider-text">{{question.slider.slider_text}}</div>
    <div class="options-slider-container border-brand-secondary">
      <div
        class="options-slider-row border-brand-tertiary position-relative"
        ref="sliderRow"
        @mousedown="startDrag"
        @mousemove="dragSelect"
        @mouseup="stopDrag"
        @mouseleave="stopDrag"
      >
        <button
          class="options-slider-button"
          :class="[option === selectedOption ? 'filled' : 'not-selected']"
          v-for="(option, index) in question.slider.options"
          :key="index"
          @click="selectOption(option)"
        >
          <span class="options-slider-index">{{option}}</span>
        </button>
        <div
          class="line bg-brand-primary"
          :style="{ '--fill':100 -  ((selectedOption - question.slider.options[0]) / (question.slider.options[question.slider.options.length - 1] - question.slider.options[0]))*100 + '%' }"
        ></div>
      </div>
    </div>
    <div class="options-slider-labels-container">
      <span class="options-slider-label">{{question.slider.min_label}}</span>
      <span class="options-slider-label">{{question.slider.max_label}}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "OptionsSlider",
  props: ["question", "answer", "setAnswer"],
  data() {
    return {
      selectedOption: 0,
      isDragging: false
    };
  },
  mounted() {
    // this.selectedOption = this.answer.score ?? this.question.slider.default_value;
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
      this.setAnswer(option, "score");
    },
    
    startDrag() {
      this.isDragging = true;
    },
    
    stopDrag() {
      this.isDragging = false;
    },
    //handling in case of dragging the slider instead of selecting the desired option
    dragSelect(event) {
      if (!this.isDragging) return;
      
      const row = this.$refs.sliderRow;
      const rect = row.getBoundingClientRect();
      const x = event.clientX - rect.left;
      
      const segmentWidth = rect.width / this.question.options.length;
      const index = Math.min(
        this.question.options.length - 1,
        Math.max(0, Math.floor(x / segmentWidth))
      );
      
      const option = this.question.options[index];
      
      if (option !== this.selectedOption) {
        this.selectedOption = option;
        this.setAnswer("score", option);
      }
    }
  }
};
</script>

<style lang="less">
#OptionsSlider {
  width: 100%;
  text-align: center;
  font-size: 1.8rem;
  display: flex;
  flex: 1 1 0px;
  flex-direction: column;
  align-items: center;
  border-radius: 20px;
  padding: 20px;
  
  .options-slider-text {
    font-size: 18px;
    margin-bottom: 16px;
    align-self: flex-start;
    text-align: start;
  }
  
  .options-slider-index {
    font-size: 1.4rem;
    font-family: "DMSans Bold";
    position: relative;
    top: 32px;
    right: 3px;
  }
  
  .options-slider-container {
    width: 100%;
    display: flex;
    flex: 1 1 0;
    justify-content: center;
    border-radius: 1000px;
    margin-bottom: 24px;
  }
  
  .options-slider-row {
    display: flex;
    flex: 1;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: space-between;
    
    .line {
      height: 16px;
      width: calc(100% - 3px);
      position: absolute;
      top: calc(50% - 8px);
      z-index: 3;
      border-radius: 20px;
      background: linear-gradient(to left,
      #f3f3f3 var(--fill),
      rgba(30, 30, 34, 0.05) var(--fill));
    }
  }
  
  .options-slider-button {
    cursor: pointer;
    width: 23px;
    height: 23px;
    border: 4px solid;
    border-color: var(--brand-primary);
    border-radius: 100px;
    z-index: 5;
    
    &.filled {
      background-color: var(--brand-primary);
    }
    
    &.not-selected {
      background-color: transparent;
      border-color: transparent;
    }
  }
  
  .options-slider-button.bg-brand-primary {
    border: none;
  }
  
  .options-slider-labels-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding-top: 30px;
    width: 100%;
  }
  
  .options-slider-label {
    font-family: "DMSans Bold";
    font-weight: 700;
    font-size: 12px;
    line-height: 140%;
    letter-spacing: 0;
    text-align: right;
    color: #797B89;
  }
  
  @media only screen and (max-width: 992px) {
    .options-slider-button {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
